import AuthorsListScreen from '../../pages/Authors/AuthorsListScreen';
import BooksListScreen from '../../pages/Books/BooksListScreen';
import HomeScreen from '../../pages/Home/HomeScreen';
import QuotesListScreen from '../../pages/Quotes/QuotesListScreen';
import SettingsScreen from '../../pages/Settings/SettingsScreen';
import TagsListScreen from '../../pages/Tags/TagsListScreen';
import ROLES from '../enums/roles';
import ChoosePhotoScreen from '../../pages/Scan/ChoosePhotoScreen';
import ImageCropperScreen from '../../pages/Scan/ImageCropperScreen';
import QuotesAddScreen from '../../pages/Quotes/QuotesAddScreen';
import ApperenceScreen from '../../pages/Settings/ApperenceScreen';
import BooksPreviewScreen from '../../pages/Books/BooksPreviewScreen';
import QuotesEditScreen from '@/pages/Quotes/QuotesEditScreen';
import AuthorsEditScreen from '@/pages/Authors/AuthorsEditScreen';
import AuthorsAddScreen from '@/pages/Authors/AuthorsAddScreen';
import TagsEditScreen from '@/pages/Tags/TagsEditScreen';
import TagsAddScreen from '@/pages/Tags/TagsAddScreen';
import BooksAddScreen from '@/pages/Books/BooksAddScreen';
import PasswordChangeScreen from '@/pages/Settings/PasswordChangeScreen';
import ProfileUpdateScreen from '../../pages/Settings/ProfileUpdateScreen';

const ROUTES = [
  {
    path: '/home',
    allowedRoles: ROLES.all(),
    component: <HomeScreen />,
  },
  {
    path: '/choose-photo',
    allowedRoles: ROLES.all(),
    component: <ChoosePhotoScreen />,
  },
  {
    path: '/scan',
    allowedRoles: ROLES.all(),
    component: <ImageCropperScreen />,
  },
  {
    path: '/books',
    allowedRoles: ROLES.all(),
    component: <BooksListScreen />,
  },
  {
    path: '/books/add',
    allowedRoles: ROLES.all(),
    component: <BooksAddScreen />,
  },
  {
    path: '/books/:id',
    allowedRoles: ROLES.all(),
    component: <BooksPreviewScreen />,
  },
  {
    path: '/books/:id/quotes/:quoteId',
    allowedRoles: ROLES.all(),
    component: <QuotesEditScreen />,
  },
  {
    path: '/tags',
    allowedRoles: ROLES.all(),
    component: <TagsListScreen />,
  },
  {
    path: '/tags/add',
    allowedRoles: ROLES.all(),
    component: <TagsAddScreen />,
  },
  {
    path: '/tags/:id',
    allowedRoles: ROLES.all(),
    component: <TagsEditScreen />,
  },
  {
    path: '/authors',
    allowedRoles: ROLES.all(),
    component: <AuthorsListScreen />,
  },
  {
    path: '/authors/add',
    allowedRoles: ROLES.all(),
    component: <AuthorsAddScreen />,
  },
  {
    path: '/authors/:id',
    allowedRoles: ROLES.all(),
    component: <AuthorsEditScreen />,
  },
  {
    path: '/quotes',
    allowedRoles: ROLES.all(),
    component: <QuotesListScreen />,
  },
  {
    path: '/quotes/add',
    allowedRoles: ROLES.all(),
    component: <QuotesAddScreen />,
  },
  {
    path: '/settings',
    allowedRoles: ROLES.all(),
    component: <SettingsScreen />,
  },
  {
    path: '/settings/profile',
    allowedRoles: ROLES.all(),
    component: <ProfileUpdateScreen />,
  },
  {
    path: '/settings/password',
    allowedRoles: ROLES.all(),
    component: <PasswordChangeScreen />,
  },
  {
    path: '/settings/apperence',
    allowedRoles: ROLES.all(),
    component: <ApperenceScreen />,
  },
];

export default ROUTES;
